import React, { useEffect, useState } from "react";
import { useEducation } from "../resume/useResumeData";
import Modal from "../../ui/Modal";

const EducationModal = ({ itemToEdit, onClose }) => {
    const { addEducation, updateEducation, isAdding, isUpdating } = useEducation();
    const [formData, setFormData] = useState({
        degree: "",
        institution: "",
        year_range: "",
        grade: "",
        description: "",
        ordering: 0,
    });

    useEffect(() => {
        if (itemToEdit) {
            setFormData({
                degree: itemToEdit.degree || "",
                institution: itemToEdit.institution || "",
                year_range: itemToEdit.year_range || "",
                grade: itemToEdit.grade || "",
                description: itemToEdit.description || "",
                ordering: itemToEdit.ordering || 0,
            });
        }
    }, [itemToEdit]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (itemToEdit) {
            updateEducation(
                { id: itemToEdit.id, ...formData },
                { onSuccess: onClose }
            );
        } else {
            addEducation(formData, { onSuccess: onClose });
        }
    };

    const isLoading = isAdding || isUpdating;

    return (
        <Modal
            isLoading={isLoading}
            onClose={onClose}
            title={itemToEdit ? "Edit Education" : "Add Education"}
        >
            <form onSubmit={handleSubmit} className="space-y-6 font-primary text-white">
                <div className="space-y-6">
                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Degree</label>
                        <input
                            type="text"
                            required
                            className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.degree}
                            onChange={(e) => setFormData({ ...formData, degree: e.target.value })}
                            placeholder="e.g. BSc Software Engineering"
                        />
                    </div>

                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Institution</label>
                        <input
                            type="text"
                            required
                            className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.institution}
                            onChange={(e) => setFormData({ ...formData, institution: e.target.value })}
                            placeholder="e.g. AWKUM Mardan"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-6">
                        <div>
                            <label className="mb-2 block text-sm font-medium text-stone-300">Year Range</label>
                            <input
                                type="text"
                                required
                                className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                                value={formData.year_range}
                                onChange={(e) => setFormData({ ...formData, year_range: e.target.value })}
                                placeholder="e.g. 2020 - 2024"
                            />
                        </div>
                        <div>
                            <label className="mb-2 block text-sm font-medium text-stone-300">Grade/GPA</label>
                            <input
                                type="text"
                                className="h-12 w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                                value={formData.grade}
                                onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
                                placeholder="e.g. 3.32/4"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="mb-2 block text-sm font-medium text-stone-300">Description</label>
                        <textarea
                            rows="4"
                            className="w-full rounded-lg border-transparent bg-transparent p-4 shadow-xl outline-none placeholder:text-stone-400 focus:border-2 focus:border-primary"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Brief description..."
                        />
                    </div>
                </div>

                <div className="flex justify-end pt-4">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="btn flex min-w-[8rem] items-center justify-center border-none bg-gradient-to-tr from-sky-600 to-cyan-400 py-3 font-semibold uppercase text-white shadow-lg hover:from-cyan-400 hover:to-sky-600 active:scale-95 disabled:opacity-50 transition-all rounded-lg"
                    >
                        {isLoading ? "Saving..." : (itemToEdit ? "Update Education" : "Save Education")}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default EducationModal;
